import * as React from 'react';
import { Button } from 'antd';
import { EditFilled, SwapOutlined } from '@ant-design/icons';
import { ARTICLE_FIRE } from '../../../consts/events';
import { observer } from 'mobx-react-lite';
import ElementWrapper from '../ElementWrapper';
import EditorStateMachine, {
  IElement
} from '../../../model/EditorStateMachine';
import { useTranslation } from 'react-i18next';
import IframeServiceInjector from '../../../services/injectors/IframeServiceInjector';
import FrameEventMessanger from '../../../services/frames/FrameEventMessanger';
import TextAiRegenrator from '../../../services/TextAiRegenrator';
import AntdCustomButton from '../../../../../components/buttons/AntdCustomButton';
import SparkleIcon from '../../../components/icons/SparkleIcon';
import PencilIcon from '../../../components/icons/PencilIcon';

interface FCProps {
  elementData: IElement;
  areaName: string;
  iframeElement: HTMLIFrameElement;
  articleId: number;
  showLoader?: boolean;
}

const TextWrapper: React.FC<FCProps> = observer(
  ({ elementData, areaName, iframeElement, showLoader, articleId }) => {
    const { t } = useTranslation();

    const areButtonsBlocked =
      EditorStateMachine.elementRegeneratingDataId !== null;

    const renderRegenerateButton = React.useCallback(() => {
      if (areaName === null) {
        return null;
      }

      return (
        <AntdCustomButton
          appearance="important"
          onMouseEnter={() => {
            EditorStateMachine.transition('onButtonHovered', {});
          }}
          onMouseLeave={() => {
            EditorStateMachine.transition('onButtonHoveredEnd', {});
          }}
          className="pointer-events-auto h-full whitespace-nowrap"
          onClick={() => {
            TextAiRegenrator.regenerateText(
              areaName,
              articleId,
              elementData.templateId
            );
          }}
          icon={<SparkleIcon width={16} height={16} fill="#FFFFFF" />}>
          {t('Regenerate text')}
        </AntdCustomButton>
      );
    }, [areaName, articleId, elementData.templateId, t]);

    return (
      <ElementWrapper
        elementData={elementData}
        iframeElement={iframeElement}
        elementId={articleId}
        showLoader={showLoader}
        hoverButton={
          <div className="flex justify-center items-center gap-2 h-full">
            {areButtonsBlocked === false && (
              <>
                {renderRegenerateButton()}
                <AntdCustomButton
                  appearance="important"
                  icon={<PencilIcon width={14} height={14} fill="#FFFFFF" />}
                  onMouseEnter={() => {
                    EditorStateMachine.transition('onButtonHovered', {});
                  }}
                  onMouseLeave={() => {
                    EditorStateMachine.transition('onButtonHoveredEnd', {});
                  }}
                  className="pointer-events-auto whitespace-nowrap"
                  onClick={(e) => {
                    e.stopPropagation();
                    IframeServiceInjector.getService<FrameEventMessanger>(
                      'FrameEventMessanger'
                    ).sendMessage(ARTICLE_FIRE, {
                      elementId: articleId
                    });

                    EditorStateMachine.transition('onEditText', {
                      elementId: articleId
                    });
                  }}>
                  {t('Edit text')}
                </AntdCustomButton>
              </>
            )}
          </div>
        }
      />
    );
  }
);

export default TextWrapper;
